module.exports = __webpack_public_path__ + "media/pages/book/components/images/main-features/mic-a5dc78b6c06e05cabacb3a1d1ab48cce.svg";